import { createAsyncThunk } from '@reduxjs/toolkit';

import { SHOPIFY_CHANNEL_TYPE } from '../../components/teammates/views/Channels/helpers/salesChannelState';

export const saveSalesChannelMapping = createAsyncThunk(
  'salesChannels/saveSalesChannelMapping',
  async (payload, { extra: { sdk, Logger } }) => {
    const {
      salesChannelId,
      type = SHOPIFY_CHANNEL_TYPE,
      core = {},
      customProductAttributes = {},
      customVariantAttributes = {},
    } = payload;

    try {
      const { data } = await sdk.setup.saveSalesChannelMapping({
        salesChannelId,
        type,
        core,
        customProductAttributes,
        customVariantAttributes,
      });
      return data;
    } catch (error) {
      Logger.error(
        new Error('Save sales channel mapping failed'),
        { error, salesChannelId },
        ['ConnectShopifyChSaveMappingFailed', { salesChannelId: salesChannelId ? String(salesChannelId) : '' }],
      );
      throw error;
    }
  },
);
